import { CallDetailsCalleeDisconnected } from 'features/call/call-details/components';
import {
  useCallDetailsCaller,
  useCallDetailsCallee,
} from 'features/call/call-details/hooks';

export const CallDetailsCalleeDisconnectedContainer = () => {
  const { caller } = useCallDetailsCaller();
  const { callee } = useCallDetailsCallee();

  return <CallDetailsCalleeDisconnected caller={caller} callee={callee} />;
};
